var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Component from '@arco-design/web-react/es/Steps';
import cx from 'classnames';
import { useConfigContext } from '../config-provider';
import IconPureCheck from '../../icon/react-icon/IconPureCheck';
var Steps = function (props, ref) {
    var className = props.className, _a = props.labelPlacement, labelPlacement = _a === void 0 ? 'vertical' : _a;
    var common = useConfigContext().prefixCls;
    var prefixCls = common + "-steps";
    var customDot = function (dot, record) {
        console.log(dot, record);
        if (record.status !== 'finish') {
            return dot;
        }
        else {
            return React.createElement("div", { className: "arco-steps-item-icon" },
                React.createElement("div", { className: "arco-steps-icon" },
                    React.createElement(IconPureCheck, { style: { fontSize: 8 } })));
        }
    };
    return React.createElement(Component, __assign({}, props, { labelPlacement: labelPlacement, ref: ref, className: cx(className, prefixCls), customDot: customDot }));
};
var ForwardRefSteps = React.forwardRef(Steps);
var StepsComponent = ForwardRefSteps;
StepsComponent.Step = Component.Step;
StepsComponent.displayName = 'Steps';
export default StepsComponent;
//# sourceMappingURL=index.js.map